import { motion } from 'framer-motion';
import { PageTransition, FadeIn } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';
import { TrainingReferenceLink } from '../components/BorderCard';

const AboutBrandPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/what" label="Back" />

      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Training Module
          </h2>
          <h1 className="text-3xl md:text-4xl font-light tracking-tight text-[#1A1A1A] mb-8">
            About The Brand
          </h1>
          
          <TrainingReferenceLink 
            href="https://canva.link/tvzacprq2ukts5l"
            label="About The Brand Reference Link"
          />
        </motion.div>

        {/* Brand Gist */}
        <FadeIn delay={0.3}>
          <div className="bg-white rounded-lg border border-[rgba(26,26,26,0.08)] p-10 md:p-12 text-center">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#D32F2F] mb-6">
              Brand Gist
            </h3>
            <p className="text-base md:text-lg text-[#1A1A1A]/80 leading-relaxed max-w-3xl mx-auto">
              The Bear House is a contemporary menswear brand focused on smart, versatile fashion. 
              It blends comfort with modern aesthetics, offering apparel that transitions seamlessly 
              from casual to refined settings. Designed for the modern man, the brand emphasizes 
              effortless style, quality, and everyday sophistication.
            </p>
            <div className="text-[9px] uppercase tracking-wider text-[#1A1A1A]/30 mt-8">
              For reference only
            </div>
          </div>
        </FadeIn>

        {/* Brand Values */}
        <FadeIn delay={0.5}>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg border border-[rgba(26,26,26,0.08)] p-6 text-center cursor-default">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#F8F6F2] border border-[rgba(26,26,26,0.1)] flex items-center justify-center">
                <span className="text-lg font-light text-[#1A1A1A]">01</span>
              </div>
              <h4 className="text-xs uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-2">
                Effortless Style
              </h4>
              <p className="text-xs text-[#1A1A1A]/60 leading-relaxed">
                Fashion that feels natural and unforced
              </p>
            </div>

            <div className="bg-white rounded-lg border border-[rgba(26,26,26,0.08)] p-6 text-center cursor-default">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#F8F6F2] border border-[rgba(26,26,26,0.1)] flex items-center justify-center">
                <span className="text-lg font-light text-[#1A1A1A]">02</span>
              </div>
              <h4 className="text-xs uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-2">
                Quality First
              </h4>
              <p className="text-xs text-[#1A1A1A]/60 leading-relaxed">
                Premium materials and craftsmanship
              </p>
            </div>

            <div className="bg-white rounded-lg border border-[rgba(26,26,26,0.08)] p-6 text-center cursor-default">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#F8F6F2] border border-[rgba(26,26,26,0.1)] flex items-center justify-center">
                <span className="text-lg font-light text-[#1A1A1A]">03</span>
              </div>
              <h4 className="text-xs uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-2">
                Everyday Sophistication
              </h4>
              <p className="text-xs text-[#1A1A1A]/60 leading-relaxed">
                Elevated looks for every occasion
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Callout Quote */}
        <FadeIn delay={0.7}>
          <div className="mt-12 bg-white rounded-lg border border-[rgba(26,26,26,0.08)] p-10 text-center cursor-default">
            <p className="text-xl md:text-2xl font-light text-[#1A1A1A] italic leading-relaxed">
              "Smart. Versatile. Contemporary."
            </p>
            <div className="text-[9px] uppercase tracking-wider text-[#1A1A1A]/30 mt-6">
              For reference only
            </div>
          </div>
        </FadeIn>

        {/* Induction Quiz - Bottom of Page */}
        <FadeIn delay={0.8}>
          <div className="mt-16 border-t border-[rgba(26,26,26,0.1)] pt-16 text-center">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#D32F2F] mb-6">
              Assessment
            </h3>
            <TrainingReferenceLink 
              href="https://docs.google.com/forms/d/e/1FAIpQLSfn-0U3P59o4vg2V1KRfYiZPprrrkHn6lxc9lKSEMVkm6l5FA/viewform?usp=publish-editor"
              label="Induction Quiz"
              subtext="Click to start the quiz"
            />
          </div>
        </FadeIn>
      </div>
    </PageTransition>
  );
};

export default AboutBrandPage;
